"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyAnnotationManager = void 0;
const empty_annotation_manager_1 = require("./empty-annotation-manager");
Object.defineProperty(exports, "EmptyAnnotationManager", { enumerable: true, get: function () { return empty_annotation_manager_1.EmptyAnnotationManager; } });
